export default {
  'search': {
    'placeholder': '區塊高度、交易哈希、賬戶地址',
    'errorTips': '目標區塊高度/交易hash/賬戶地址錯誤'
  },
  'common': {
    'time': {
      's': '秒前',
      'm': '分鐘前',
      'h': '小時前'
    },
    'nav': {
      'index': '首頁',
      'txList': '交易列表'
    },
    'txType': {
      'payCoin': '轉移BU',
      'invokeContract': '調用合約',
      'createContract': '創建合約',
      'issueAsset': '發行Token',
      'createAccount': '創建賬戶',
      'unknown': '賬戶',
      'payAsset': '轉移Token'
    },
    'txStatus': {
      'success': '成功',
      'fail': '失敗'
    },
    'errorMsg': {
      'dealing': '交易正在處理',
      'noBalance': '余額不足',
      'noActive': '激活目標賬戶費用不足',
      'unknownError': '未知錯誤'
    },
    'accType': {
      'normal': '普通賬戶',
      'unite': '聯名賬戶',
      'contract': '合約賬戶'
    },
    'tabelName': {
      'time': '時間',
      'age': '年龄',
      'block': '所在區塊',
      'txtype': '交易類型',
      'fromAddress': '源賬戶',
      'toAddres': '目的賬戶',
      'amount': '數量',
      'hash': '交易哈希',
      'status': '狀態'
    },
    'btn': {
      'json': '原始數據',
      'formate': '格式化',
      'unFormate': '去格式化',
      'switchTo': '切換原文',
      'switchBack': '切換密文',
      'testBtn': '測試網入口',
      'mainBtn': '主網入口',
      'showAll': '全部展開',
      'showLess': '收起'
    },
    'nomace': '筆',
    'hashError': '目標交易hash不存在',
    'accountError': '目標賬戶地址錯誤',
    'blockError': '目標區塊不存在',
    'tableNoData': '暫無數據',
    'tableLoading': '數據加載中...',
    'webkitWarn': '溫馨提示：為了更好的呈現用戶體驗，推薦您使用Chrome或Safari瀏覽器瀏覽本網站'
  },
  'index': {
    'totalData': {
      'title': '概覽',
      'node': '實時節點數',
      'averageTime': '區塊平均生成時間',
      'seq': '區塊高度',
      'price': 'BU價格',
      'lastBlock': '最新區塊',
      'txNum': '總交易數',
      'accountNum': '總賬戶數',
      'days': '運行天數',
      'day': '天',
      'chartsTitle': '雙周BU交易數',
      'chartsTips': '交易數',
      'more': '更多'
    },
    'block': {
      'title': '區塊',
      'secTitle': '（最新生成）',
      'label': {
        'time': '時間',
        'age': '年齡',
        'height': '高度',
        'size': '大小（Byte）',
        'reward': '塊收益',
        'hash': '塊哈希'
      }
    },
    'tx': {
      'title': '交易',
      'secTitle': '（最新生成）',
      'label': {
        'time': '時間',
        'age': '年齡',
        'block': '所在區塊',
        'txType': '交易類型',
        'fromAddress': '源賬戶',
        'toAddress': '目的賬戶',
        'amount': '數量',
        'hash': '交易哈希',
        'status': '狀態'
      }
    }
  },
  'account': {
    'baseInfo': {
      'title': '賬戶',
      'itemName': {
        'balance': 'BU數量',
        'accType': '賬戶類型',
        'siners': '共管成員',
        'thresholds': '門限',
        'contract': '合約代碼'
      }
    },
    'asset': {
      'listName': 'ZTP10資產列表',
      'assetName': '資產ID',
      'amount': '數量',
      'address': '資方賬戶地址'
    },
    'asset20': {
      'listName': 'ZTP20資產列表',
      'assetCode': '資產ID',
      'assetName': '資產名稱',
      'amount': '數量',
      'contract': '資產合約'
    },
    'lastTx': {
      'moreLink': '更多交易',
      'listName': '最近5筆交易'
    },
    'accountTxList': {
      'title': '交易：賬戶'
    }
  },
  'block': {
    'baseInfo': {
      'title': '區塊',
      'itemName': {
        'blockReward': '區塊獎勵',
        'txCount': '交易數',
        'seq': '區塊高度',
        'ledgerSize': '區塊大小',
        'version': '區塊版本',
        'time': '區塊生成時間',
        'hash': '區塊哈希',
        'previousHash': '上壹區塊哈希',
        'accountTreeHash': '賬戶樹哈希',
        'consensusValueHash': '共識信息哈希',
        'validatorsHash': '共識節點哈希'
      },
      'prevBlockBtn': '前壹個區塊',
      'nextBlockBtn': '後壹個區塊'
    },
    'blockTx': {
      'title': '包含的交易'
    }
  },
  'tx': {
    'list': {
      'listTitle': '交易列表'
    },
    'baseInfo': {
      'title': '交易哈希',
      'itemName': {
        'time': '時間',
        'age': '年龄',
        'ledgerSeq': '區塊高度',
        'txType': '交易狀態',
        'fee': '交易費用',
        'sourceAddress': '發起人賬戶地址',
        'signatureStr': '簽名者'
      }
    },
    'operate': {
      'title': '操作',
      'secTitle': '（操作指創建賬戶、轉賬、調用合約、發行資產等）',
      'payCoin': {
        'name': '轉移BU',
        'itemName': {
          'fromAddress': '源賬戶地址',
          'toAddress': '目的賬戶地址',
          'amount': 'BU數量'
        }
      },
      'payAsset': {
        'name': '轉移token',
        'itemName': {
          'fromAddress': '源賬戶地址',
          'toAddress': '目的賬戶地址',
          'assetCode': '資產ID',
          'amount': '數量'
        }
      },
      'createAccount': {
        'name': '創建賬戶',
        'itemName': {
          'destAddress': '賬戶地址',
          'initBalance': '初始BU數量',
          'accType': '賬戶類型',
          'signers': '共管成員',
          'thresholds': '門限'
        }
      },
      'createContract': {
        'name': '創建合約',
        'itemName': {
          'destAddress': '合約地址',
          'initBalance': '初始BU數量',
          'contract': '合約script'
        }
      },
      'issueAsset': {
        'name': '發行token',
        'itemName': {
          'assetIssuer': '資方賬戶地址',
          'assetCode': '資產ID',
          'amount': '發行數量'
        }
      },
      'invokeContract': {
        'name': '調用合約',
        'itemName': {
          'fromAddress': '合約執行人賬戶',
          'toAddress': '合約地址'
        }
      }
    }
  }
}
